import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    version: ''
  },
  getters: {
    version (state) {
      return state.version
    }
  },
  mutations: {
    setVersion (state, version) {
      state.version = version
    }
  },
  actions: {
    setVersion (context, version) {
      context.commit('setVersion', version)
    }
  },
  modules: {
  }
})
